module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Bold.a123e4e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Bold.woff
// module id = v3K6
// module chunks = 0